export const HOME = {
  emergentLink: "emergent-link",
  urlInput: "url-input",
  fetchButton: "fetch-button",
  previewCard: "preview-card",
  downloadButton: "download-button",
  metaTitle: "meta-title",
  metaArtist: "meta-artist",
  metaAlbum: "meta-album",
  metaComment: "meta-comment",
  metaCreationTime: "meta-creation-time",
  resetMeta: "reset-meta",
  historySection: "history-section",
  clearHistory: "clear-history",
  faqSection: "faq-section",
};
